import React from "react";
import { Button } from "./ui/button";
import { usePopup } from "../context/PopupContext";
import { ArrowRight, MessageCircle } from "lucide-react";

export const CTABanner = ({
  eyebrow = "Ready to get noticed on Wikipedia?",
  title = "Let's create a page the world can trust.",
  subtitle = "Join 400+ individuals and brands that rely on us for accurate, policy-compliant Wikipedia pages.",
  primaryLabel = "Create Wiki Page",
  showChat = true,
  className = "",
}) => {
  const { openPopup } = usePopup();
  return (
    <section className={`relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`} data-testid="cta-banner">
      <div
        className="relative overflow-hidden rounded-3xl p-8 sm:p-12 md:p-16"
        style={{ background: "linear-gradient(135deg, #0A2540 0%, #123B6E 55%, #10B981 180%)" }}
      >
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 opacity-30"
          style={{
            backgroundImage:
              "radial-gradient(circle at 85% 20%, rgba(16,185,129,0.5) 0, transparent 40%), radial-gradient(circle at 10% 90%, rgba(59,130,246,0.5) 0, transparent 40%)",
          }}
        />
        <div className="relative max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-white backdrop-blur">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" /> {eyebrow}
          </span>
          <h3 className="font-serif mt-4 text-3xl font-semibold leading-[1.1] text-white sm:text-4xl md:text-5xl">
            {title}
          </h3>
          <p className="mt-4 max-w-2xl text-sm text-white/80 sm:text-base">{subtitle}</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Button
              onClick={openPopup}
              className="h-12 rounded-full bg-emerald-500 px-6 text-sm font-semibold text-white hover:bg-emerald-400"
              data-testid="cta-banner-primary"
            >
              {primaryLabel} <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            {showChat ? (
              <button
                className="chat inline-flex h-12 items-center gap-2 rounded-full border border-white/30 bg-white/10 px-6 text-sm font-semibold text-white hover:bg-white/20"
                data-testid="cta-banner-chat"
              >
                <MessageCircle className="h-4 w-4" /> Chat with a Specialist
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
